<app-central-loader text="Aguarde um instante"></app-central-loader>